<template>
  <div class="inside_wrapper">
    <el-divider content-position="left">修改密码</el-divider>
    <el-form :model="form" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="原密码" prop="Password">
        <el-input class="w300" type="password" v-model="form.Password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="NewPwd">
        <el-input class="w300" type="password" v-model="form.NewPwd" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="PassConfirm">
        <el-input class="w300" type="password" v-model="form.PassConfirm" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm(ruleForm)">确认</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs,ref } from "vue";
import useWrapper from "./useChangePassword"
// import { useRoute } from "vue-router";
export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    const {rawData,submitForm} = useWrapper()
    const ruleForm = ref<HTMLElement | null>(null);
    //*********** definning variables end **********//
    //*********** initData start **********//
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    //*********** DOM FUN end **********//
    return {
      ...toRefs(rawData),ruleForm,submitForm
    }
  },
});
</script>
<style lang="scss">

</style>
